<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="800px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="摄影师" prop="userIdMain">
            <el-select v-model="addForm.userIdMain" filterable remote placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading">
              <el-option v-for="item in userList" :key="item.userId" :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`" :value="item.userId"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="摄影师助理">
            <el-select
              style="margin-right: 5px"
              v-model="addForm.userIdDeputy"
              filterable
              remote
              placeholder="请输入关键词"
              :remote-method="remoteMethod1"
              :loading="loading"
              clearable
            >
              <el-option v-for="item in userList1" :key="item.userId" :label="`${item.userName}${item.workNo ? '-' + item.workNo : ''}`" :value="item.userId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from "@/utils/axiosInstance";
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  data() {
    return {
      addForm: {},
      userId: "",
      userList: [],
      userList1: [],
      all: false,
      rules: {
        userIdMain: [{ required: true, message: "不能为空", trigger: "change" }],
      },
      loading: false,
      loadingButtom: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
        oneIndex: 0,
        towIndex: 0,
      },
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return "编辑";
    },
  },
  mounted() {
    if (this.rowData) {
      let addForm = JSON.parse(JSON.stringify(this.rowData));
      this.addForm = addForm;
      this.addForm.userIdMain = addForm.userIdMain + "";
      this.addForm.userIdDeputy = addForm.userIdDeputy ? addForm.userIdDeputy + "" : "";
      this.remoteMethod(addForm.userNameMain);
      this.remoteMethod1(addForm.userNameDeputy);
    }
    console.log(this.addForm);
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        this.$q.newProduct
          .cameramanConfigUpdate({ data: this.addForm })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + "成功";
              this.$message.success(text);
              this.isVisible = false;
              this.$emit("success");
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
    remoteMethod(query) {
      console.log(query);
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.userList = res.data.list;
          this.loading = false;
        }
      });
    },
    remoteMethod1(query) {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "searchUserInfoByName";
      currencyForm.pageSize = 100;
      currencyForm.param = {
        userName: query,
      };
      axios.post(`/ec-pc-api/custom/reports/data/searchUserInfoByName`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.userList1 = res.data.list;
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>

 >>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 200px !important;
}
</style>
